(function (ws) {
    'use strict';
    ws.views.loginNavigation = Backbone.View.extend({
        /**
         * Initialize method.
         */
        initialize() {
            this.$arrowIcon = this.$('.vrf-arrow-icon');
            this.eventAgg.on('showLoginCountryBox', this.toggleArrowIcon.bind(this));
        },

        /**
         * Toggles the arrow icon from up to down and back.
         *
         * @param {boolean} isShowing
         */
        toggleArrowIcon(isShowing) {
            if (isShowing) {
                this.$arrowIcon
                    .removeClass('icon-downarrow')
                    .addClass('icon-uparrow');
            }
            else {
                this.$arrowIcon
                    .removeClass('icon-uparrow')
                    .addClass('icon-downarrow');
            }
        }
    });
})(westcon);
